export default __webpack_public_path__ + "static/media/memberarea.a8dc9606.webp";